import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    box-sizing: border-box;
    line-height: 1em;
    @apply --type-base;
    @apply --heavy;
    color: inherit;
    font-size: inherit;
  }

  /*
  * Marketing Presentation
  */
  :host([presentation="marketing"]) {
    @apply --layout-horizontal;
  }

  :host([presentation="marketing"]) #decimalAndCurrencyWrapper {
    margin-left: 2px;
    @apply --layout-vertical;
    margin-top: 0.12em;
  }

  :host([presentation="marketing"]) #decimalsWithinStack {
    text-align: left;
    font-size: 0.55em;
    letter-spacing: 0.05em;
    line-height: 0.9em;
  }

  :host([presentation="marketing"]) #currency {
    text-align: left;
    font-size: 0.35em;
    font-weight: 500;
    line-height: 0.8em;
  }

  :host([presentation="marketing"]) #symbol {
    @apply --layout-self-start;
    font-size: 0.56em;
    line-height: 1em;
    margin-top: 0.1em;
  }

  :host([hide-decimals]) {
    @apply --layout-baseline;
  }

  /*
  * Commerce Presentation
  */
  :host([presentation="commerce"]) {
    @apply --layout-horizontal;
    @apply --layout-baseline;
  }

  :host([presentation="commerce"]) #currency {
    font-size: 0.67em;
    font-weight: 400;
    padding-left: 0.25em;
    line-height: 1em;
    @apply --com-price-currency;
    @apply --com-price-currency-xs;
  }

  /*
  * Inline Presentation
  */
  :host([presentation="inline"]) {
    @apply --layout-inline;
    @apply --layout-baseline;
    font-weight: inherit;
  }

  /*
  * LACD Delta+ Styles
  */
  #symbol {
    @apply --com-price-symbol;
  }

  #price {
    @apply --com-price-price;
  }
  /* End LACD Delta+ Styles*/
</style>
</template>`;

styleElement.register('com-price-style');